import React from 'react';
import {
  IndexRouteProps,
  LayoutRouteProps,
  PathRouteProps,
  Route,
} from 'react-router-dom';
type BreadCrumb = { breadcrumb: any };
type BreadCrumbRouteType = (
  _props: PathRouteProps | LayoutRouteProps | IndexRouteProps | BreadCrumb,
) => React.ReactElement<any, string | React.JSXElementConstructor<any>> | null;
const BreadCrumbRoute: BreadCrumbRouteType = Route;

export { BreadCrumbRoute as Route };
